module.exports = __webpack_public_path__ + "img/casino-hitech.13762e26.png";